export default __webpack_public_path__ + "static/farmer-8bb98d5e41637dd0091daa2db7ead809.png";